import React from 'react';

import PropTypes from 'prop-types';

import { useFeatures } from '@atc/features';

import { Col } from 'reaxl';
import { MyWalletGridContainer as ConnectedMyWalletGrid } from 'reaxl-wallet';

import paymentsDuck from '@/ducks/paymentsDuck.js';

function MyWalletGridContainer({ uiContext, showIcon }) {
    const {
        srp_wallet_grid_promo_card: [enableWalletPromoCard],
    } = useFeatures(['srp_wallet_grid_promo_card']);

    return (
        !enableWalletPromoCard
        && (
            <Col xs={12}>
                <ConnectedMyWalletGrid
                    paymentsDuck={paymentsDuck}
                    showIcon={showIcon}
                    uiContext={uiContext || 'basic'}
                />
            </Col>
        )

    );
}

MyWalletGridContainer.propTypes = {
    /**
     * Bool to show/hide icon
     */
    showIcon: PropTypes.bool,
    /**
     * uiContext for themes
     */
    uiContext: PropTypes.oneOf(['default', 'basic', 'light', 'welcome']),
};

export default MyWalletGridContainer;
